import React from "react";
import { FileManager, FileUploader } from "reactjs-file-uploader";
import { SAVED_ICON, VIDEO_FILE, RAR_FILE } from "./SrcImages";
import { Label, Input, Row, Col, Button } from "reactstrap";
import moment from "moment";
interface IFileUploadState {
  files: any;
  type: string;
  format: string;
  msg_error: string;
  nameImg: string;
  IMG_AVATAR: string;
  urlHttp: string;
  setNameFile: any;
}

interface IFileUploadProps {
  nameImg: string;
  IMG_AVATAR: string;
  urlHttp: string;
  setNameFile: any;
}
class VanillaExample extends React.Component<
  IFileUploadProps,
  IFileUploadState
> {
  constructor(props: IFileUploadProps) {
    super(props);
    this.state = {
      files: [],
      type: "img",
      format: "",
      msg_error: "",
      nameImg: props.nameImg,
      IMG_AVATAR: props.IMG_AVATAR,
      urlHttp: props.urlHttp,
      setNameFile: props.setNameFile,
    };
    this.uploadFiles = this.uploadFiles.bind(this);
    this.uploadFile = this.uploadFile.bind(this);
    this.fileProgress = this.fileProgress.bind(this);
  }
  //   .includes("video")
  render() {
    const props = this.state;
    return (
      <React.Fragment>
        <Row>
          {props.files.length === 0 ? (
            <React.Fragment>
              <Col xs={12} className="text-center mt-2 mb-3">
                <img src={props.IMG_AVATAR} className="img-avatar" alt=""></img>
              </Col>
              <Col sm={1} className="text-center"></Col>
              <Col sm={10}>
                <Input
                  type="file"
                  className="m-auto"
                  // accept="image/x-png,image/jpg,image/jpeg,video/mp4"
                  /* tslint:disable-next-line */
                  onChange={(event) => {
                    var msg_error = "";
                    var lenght_type = 4;
                    var type = "";
                    if (event.target.files[0].type.includes("jpeg")) {
                      lenght_type = 5;
                    }
                    if (event.target.files[0].name.includes("docx")) {
                      lenght_type = 5;
                    }
                    if (
                      event.target.files[0].name.includes(".zip") ||
                      event.target.files[0].name.includes(".rar")
                    ) {
                      type = event.target.files[0].name.substring(
                        event.target.files[0].name.length - lenght_type
                      );
                    } else if (
                      event.target.files[0].name.includes(".jpeg") ||
                      event.target.files[0].name.includes(".jpg") ||
                      event.target.files[0].name.includes(".png")
                    ) {
                      type = "imagen";
                    } else {
                      type = "video";
                    }

                    var name_file =
                      this.state.nameImg +
                      "_" +
                      moment(new Date().toString()).format(
                        "YYYY_MM_DD_HH_mm_ss"
                      ) +
                      event.target.files[0].name.substring(
                        event.target.files[0].name.length - lenght_type
                      );
                    if (event.target.files[0].size > 24214400) {
                      msg_error = "Peso del archivo supero los 25mb";
                      this.setState({ msg_error });
                    } else {
                      this.setState({
                        files: props.files.concat(
                          Array.from(event.target.files)
                        ),
                        type,
                        format: name_file,
                        msg_error: "",
                      });
                    }
                  }}
                />
              </Col>
              <Col sm={1} className="text-center">
                {" "}
              </Col>
            </React.Fragment>
          ) : null}

          <Col sm={12}>
            <FileManager files={props.files}>{this.uploadFiles}</FileManager>
          </Col>
          <Col sm={12} className="text-center mt-3">
            {this.state.msg_error.length > 0 ? (
              <Label className="l-color-danger">{this.state.msg_error}</Label>
            ) : (
              <Label>
                {props.files.length === 0 ? (
                  <Label className="l-color-danger">
                    Formatos permitidos: .mp4 .jpg .png .zip .doc .docx .pdf
                  </Label>
                ) : (
                  ""
                )}
              </Label>
            )}
          </Col>
        </Row>
      </React.Fragment>
    );
  }

  uploadFiles(files) {
    return files.map(this.uploadFile);
  }

  uploadFile(file) {
    return (
      <FileUploader
        key={file.key}
        file={file}
        url={this.state.urlHttp}
        formData={{
          file,
          upload_preset: "public",
          tags: "vanilla",
          per_id: this.state.nameImg,
          nameImg: this.state.format,
        }}
        readFile
      >
        {this.fileProgress}
      </FileUploader>
    );
  }

  fileProgress({
    uploadReady,
    uploadStart,
    uploadProgress,
    uploadComplete,
    downloadStart,
    downloadProgress,
    downloadComplete,
    error,
    abort,
    timeout,
    requestState,
    startUpload,
    abortRequest,
    request,
    response,
    fileData,
  }) {
    return (
      <Row>
        <Col sm={12} className="text-center">
          {this.state.type.includes("video") ? (
            <img
              src={VIDEO_FILE}
              width={200}
              alt="Preview"
              className="img-avatar"
            />
          ) : this.state.type.includes("imagen") ? (
            <img
              src={fileData}
              width={200}
              alt="Preview"
              className="img-avatar"
            />
          ) : (
            <img
              src={RAR_FILE}
              width={200}
              alt="Preview"
              className="img-avatar"
            />
          )}
        </Col>
        <Col sm={12} className="text-center mt-4">
          {startUpload && (
            <Button
              className="info mt-2"
              onClick={() => {
                startUpload();
                this.state.setNameFile({ name_file: this.state.format });
              }}
            >
              Guardar
            </Button>
          )}
        </Col>
        <Col sm={12} className="save-upload-img">
          {response && (
            <React.Fragment>
              <Label>Guardado</Label>
              <img className="img-status img-search" src={SAVED_ICON} alt="" />
            </React.Fragment>
          )}
        </Col>
      </Row>
    );
  }
}
export default VanillaExample;
